import React, { useContext } from 'react';

import RegistrationWrapper from 'common/canny/register/RegistrationWrapper';
import { ViewerContext } from 'common/containers/ViewerContainer';
import VStack from 'common/ui/VStack';
import getFirstName from 'common/util/getFirstName';

import AdminOnboardingFieldLabel from './AdminOnboardingFieldLabel';
import AdminOnboardingMultiSelect from './AdminOnboardingMultiSelect';
import { whatOptions } from './data';

import type { UseCase } from './Types';

type Props = {
  onChange: (useCase: UseCase) => void;
  useCase: UseCase;
};

const AdminOnboardingWhat = ({ onChange, useCase }: Props) => {
  const viewer = useContext(ViewerContext);

  const onChangeSelect = (motivations: string[]) => {
    onChange({
      ...useCase,
      motivations,
    });
  };

  const { motivations } = useCase;
  const name = getFirstName(viewer?.name) || 'there';

  return (
    <RegistrationWrapper.Content className="gap-6">
      <RegistrationWrapper.Header>
        <RegistrationWrapper.Title>Hey {name}, what brings you to Canny?</RegistrationWrapper.Title>
      </RegistrationWrapper.Header>
      <VStack className="gap-2">
        <AdminOnboardingFieldLabel isRequired>Select all that apply</AdminOnboardingFieldLabel>
        <AdminOnboardingMultiSelect
          optionType="card"
          onChange={onChangeSelect}
          options={whatOptions}
          selected={motivations}
        />
      </VStack>
    </RegistrationWrapper.Content>
  );
};

export default AdminOnboardingWhat;
